import { render, staticRenderFns } from "./RollBanner.vue?vue&type=template&id=a3cbd50a&scoped=true"
import script from "./RollBanner.vue?vue&type=script&lang=js"
export * from "./RollBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cbd50a",
  null
  
)

export default component.exports